export default
`
Dietary restriction has shown to increase lifespan in organisms ranging from yeast to mammals, although the underlying mechanism remains unclear. In this project we analysed the complete set of proteins (the proteome) inside budding yeast cells to identify proteins that mediate lifespan extension through dietary restriction.\r\n

You can read the full publication at [https://portlandpress.com/biochemj/article/478/24/4153/229950/Proteomic-analysis-of-dietary-restriction-in-yeast](https://portlandpress.com/biochemj/article/478/24/4153/229950/Proteomic-analysis-of-dietary-restriction-in-yeast) 
`


// WEBPACK FOOTER //
// ./src/content/understanding-dietary-restriction.js